import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AccessRights, UsersService, InterfacePermissions } from "../../services/users.service";

@Component({
    selector: 'app-admin-panel',
    templateUrl: './admin-panel.component.html',
    styleUrls: ['./admin-panel.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AdminPanelComponent implements OnDestroy,OnInit  {
  public InterfacePermissions = InterfacePermissions;

  constructor(public usersService: UsersService) {

  }

  ngOnInit() {
    this.selected = "admin_objects";
  }
  ngOnDestroy(): void {
    //window.dispatchEvent(new CustomEvent("ProfileChanged"));
  }
  public selected:string;

  public select(name: string) {
    this.selected = name;
  }

  public isSelected(name:string) {
    return name == this.selected;
  }
}
